import { AxiosInstance } from "axios"
import { CustomJob, CustomReportsType } from "./customReportsTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

export enum AccountingCustomReportsQuery {
    CUSTOM_REPORTS_LIST = "custom-reports-for-merchant",
}

type CustomReportsParams = Readonly<{
    merchantId: number
    type: CustomReportsType
}>

export type CustomReportsResponse = Readonly<{
    customJobs: CustomJob[]
}>

export async function fetchCustomReports(
    params: CustomReportsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CustomReportsResponse> {
    const { merchantId, ...rest } = params

    const url = `/merchants/${merchantId}/accounting/customReports`

    const { data } = await axios.get(url, {
        params: rest,
        signal,
    })

    return data
}

type UpdateCustomJobParam = Readonly<{
    jobId: number
    isActive: boolean
}>

export async function updateCustomJob(
    { jobId, isActive }: UpdateCustomJobParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/integrations/customJobs/${jobId}`,
        {
            customJob: {
                isActive,
            },
        },
        {
            signal,
        },
    )
    return data
}

type RunCustomJobParam = Readonly<{
    jobId: number
    startDate?: string
    endDate?: string
}>

export async function runCustomJob(
    { jobId, startDate, endDate }: RunCustomJobParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const params = startDate && endDate ? `?startDate=${startDate}&endDate=${endDate}` : ""
    const { data } = await axios.post(
        `/integrations/customJobs/${jobId}/run${params}`,
        {},
        {
            signal,
        },
    )
    return data
}
